import store from '@/store'
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'

type InternalAdminContext = {
  to: RouteLocationNormalized
  next: NavigationGuardNext
  from: RouteLocationNormalized
}

const internalAdmin = async ({ to, next, from }: InternalAdminContext): Promise<void> => {
  const isAuth = localStorage.getItem('token')

  if (!isAuth) {
    sessionStorage.setItem('userRequestUrl', JSON.stringify({ name: to.name, query: to.query, params: to.params }))
    const company = to?.params?.company as string | undefined
    if (company) {
      return next({ name: 'company-login', params: { company } })
    }
    return next({ name: 'login' })
  }
  if (!(store as any).state.user.currentUser) {
    await (store as any).dispatch('user/getCurrentUser', to.params.company)
  }
  if ((store as any).getters['user/isAdmin']) {
    return next()
  }
  return next(from)
}

export default internalAdmin
